// MessageModal.jsx
import React, { useEffect, useState } from "react";
import { Modal, Button } from "antd";

const MessageModal = ({ visible, onClose, message, autoCloseTime = 15000 }) => {
  const [isVisible, setIsVisible] = useState(visible);

  useEffect(() => {
    setIsVisible(visible);

    if (visible) {
      const timer = setTimeout(() => {
        handleClose();
      }, autoCloseTime);

      return () => clearTimeout(timer); // cleanup on unmount or re-open
    }
  }, [visible, autoCloseTime]);

  const handleClose = () => {
    setIsVisible(false);
    if (onClose) onClose();
  };

  return (
    <Modal
      title="Information"
      visible={isVisible}
      onCancel={handleClose}
      footer={[
        <Button key="close" type="primary" onClick={handleClose}>
          Close
        </Button>,
      ]}
    >
      <p>{message}</p>
    </Modal>
  );
};

export default MessageModal;
